import styled from 'styled-components'
import React, { useContext, useState } from 'react'
import { Title, TitleHint } from './components'
import { EditorContext } from '../../../utils/contexts'
import { useHistory, useRouteMatch } from 'react-router-dom'
import { withEditorPageTracking } from '../../../shared/Tracking'

const FORM_TYPES = [
  {
    id: 'survey',
    title: 'Survey',
    description: 'Collect structured feedback with multiple question types.',
  },
  {
    id: 'poll',
    title: 'Poll',
    description: 'Quick single or multi-question polls to gauge opinions.',
  },
  {
    id: 'quiz',
    title: 'Quiz',
    description: 'Engage visitors with scored knowledge or personality quizzes.',
  },
  {
    id: 'lead_gen',
    title: 'Lead Generation',
    description: 'Capture contact details and qualify leads for your CRM.',
  },
  {
    id: 'feedback',
    title: 'Feedback',
    description: 'Collect bug reports, support details, and open feedback.',
  },
  {
    id: 'salesforce',
    title: 'Salesforce',
    description: 'Capture leads and sync them directly to Salesforce CRM.',
  },
]

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-top: 4px;
`

const TypeCard = styled.div`
  border: 2px solid ${p => p.active ? '#636363' : '#dcdcdc'};
  border-radius: 8px;
  padding: 14px 12px;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;
  background: ${p => p.active ? '#fafafa' : '#fff'};
  &:hover {
    border-color: #636363;
    box-shadow: 0 2px 6px rgba(0,0,0,0.08);
  }
`

const TypeTitle = styled.h6`
  font-size: 0.88em;
  font-weight: 700;
  color: #333;
  margin: 0 0 4px;
`

const TypeDesc = styled.p`
  font-size: 0.78em;
  color: #777;
  line-height: 1.35;
  margin: 0 0 6px;
`

function FormTypeStep({ className }) {
  const { dispatch, siteSettings } = useContext(EditorContext)
  const history = useHistory()
  const match = useRouteMatch()
  const [active, setActive] = useState(null)

  const onSelect = (formType) => {
    setActive(formType.id)

    // Find the first available template matching this form type so we can
    // pre-populate form_questions — same data chooseTheme() sets in ThemeSelector.
    const templates = siteSettings?.available_form_templates || []
    const defaultTemplate = templates.find(t => t.form_type === formType.id) || templates[0]

    dispatch({
      type: 'update',
      payload: {
        form_type: formType.id,
        form_template_theme: defaultTemplate?.form_template_theme || 'customer-feedback-survey',
        form_template_id: defaultTemplate?.id || null,
        form_template_name: defaultTemplate?.name || null,
        form_questions: defaultTemplate?.defaults?.questions || [],
        theme_id: null,
        theme: null,
      },
    })
    history.push(
      `/sites/${match.params.siteId}/popups/${match.params.popupId}/design`
    )
  }

  return (
    <div className={className}>
      <Title>Form Type</Title>
      <TitleHint>What kind of form do you want to create?</TitleHint>
      <Grid>
        {FORM_TYPES.map((ft) => (
          <TypeCard key={ft.id} active={active === ft.id} onClick={() => onSelect(ft)}>
            <TypeTitle>{ft.title}</TypeTitle>
            <TypeDesc>{ft.description}</TypeDesc>
          </TypeCard>
        ))}
      </Grid>
    </div>
  )
}

export default styled(withEditorPageTracking(FormTypeStep, 'FormType'))`
  padding: 1em 0;
`
